<template>
  <div class="rooms-body">
    <loader :isShow="isLoading && hasLoaded && !isFiltering" :textInfo="''" />
    <section class="rooms-top-container">
      <div class="rooms-title">My Rooms</div>
      <div class="rooms-nav-container">
        <div class="right" style="display: flex">
          <v-popover
            class="trigger"
            offset="16"
            :auto-hide="true"
            placement="bottom-end"
          >
            <button class="select-btn">
              <span>Occupancy</span>
              <img class="down-arrow" src="@/assets/DownGreyArrow.svg" />
            </button>

            <template slot="popover">
              <GenericSearchCheckBoxMenu
                @occupancy-checked="filterOccupancy"
                :checked="filteredOccupancy"
                displayProperty="name"
                :things="occupancy"
                searchThing="occupancy"
                displaySearch="false"
                :key="'calendar-property-filter'"
              />
            </template>
          </v-popover>

          <v-popover
            class="trigger"
            offset="16"
            :auto-hide="true"
            placement="bottom-end"
          >
            <button class="select-btn">
              <span>Properties</span>
              <img class="down-arrow" src="@/assets/DownGreyArrow.svg" />
            </button>

            <template slot="popover">
              <GenericSearchCheckBoxMenu
                @property-checked="filterProperties"
                :checked="filteredProperties"
                displayProperty="name"
                :things="properties"
                searchThing="property"
                :key="'calendar-property-filter'"
              />
            </template>
          </v-popover>
        </div>
        <Button
          @click="createRoom()"
          id="newTemplateButton"
          class="roomScreenButton"
        >
          New Room
        </Button>
      </div>
    </section>

    <section v-if="showSkeleton" class="rooms-loading">
      <RoomsSkeleton />
    </section>

    <section v-if="!showSkeleton" class="rooms-grid">
      <template>
        <RoomCell
          v-for="room in this.rooms"
          :key="room.uuid"
          @edit="triggerEdit(room, rooms)"
          @delete="triggerDelete(room)"
          @showRoomDetail="showRoomDetail"
          :room="room"
        />
        <room-detail :roomId="selRoom ? selRoom.uuid : ''" />
      </template>
    </section>

    <section v-if="deleting == true" class="rooms-delete-background">
      <delete-popup
        v-if="deleting == true"
        @confirm="deleteRoom"
        @cancel="deleting = false"
        :thingName="'Room'"
      />
    </section>

    <section class="empty-room-screen" v-if="showEmptyState">
      <img class="room-empty-icon" src="../../assets/room_empty_icon.svg" />
      <div>Add your first room</div>
      <Button
        @click="createRoom(rooms)"
        id="newTemplateButton"
        class="roomScreenButton"
      >
        New Room
      </Button>
    </section>

    <section class="empty-room-screen" v-if="showNoFilterResults">
      <img class="room-empty-icon" src="../../assets/no_filtered_chores.svg" />
      <div>No rooms match your filters</div>
      <Button
        @click="clearFilters"
        id="newTemplateButton"
        class="roomScreenButton"
      >
        Clear Filters
      </Button>
    </section>
  </div>
</template>

<script>
import { Button } from 'ant-design-vue'
import RoomCell from '@/components/rooms/RoomCell.vue'
import calls from '@/api/calls.js'
import DeletePopup from '../../components/GenericDeletePopup.vue'
import GenericSearchCheckBoxMenu from '@/components/GenericSearchCheckBoxMenu'
import RoomDetail from '@/screens/rooms/RoomDetail.vue'
import Loader from '@/components/Loader.vue'
import RoomsSkeleton from '@/components/shared/RoomsSkeleton.vue'
import roomsApi from '../../api/rooms'

export default {
  name: 'MyRoomsScreen',
  components: {
    RoomCell,
    DeletePopup,
    GenericSearchCheckBoxMenu,
    RoomDetail,
    Loader,
    RoomsSkeleton,
    Button
  },
  data() {
    return {
      rooms: [],
      isLoading: true,
      hasLoaded: false,
      isFiltering: false,
      filterDebounceMs: 800,
      filterDebounceTimer: null,
      filterDirty: false,
      deleting: false,
      selRoom: null,
      properties: [],
      selProperty: null,
      filteredProperties: [],
      filteredOccupancy: ['green', 'yellow', 'red'],
      occupancy: [
        {
          uuid: 'green',
          name: '>= 90%'
        },
        {
          uuid: 'yellow',
          name: '>= 70% and < 90%'
        },
        {
          uuid: 'red',
          name: '< 70%'
        }
      ]
    }
  },
  computed: {
    noRooms() {
      return this.rooms.length === 0
    },
    isInitialLoading() {
      return this.isLoading && !this.hasLoaded
    },
    showSkeleton() {
      return this.isInitialLoading || this.isFiltering
    },
    isFilterActive() {
      return (
        this.filteredOccupancy.length !== this.occupancy.length ||
        this.filteredProperties.length > 0
      )
    },
    showEmptyState() {
      return (
        this.hasLoaded &&
        !this.isLoading &&
        this.noRooms &&
        !this.isFilterActive
      )
    },
    showNoFilterResults() {
      return (
        this.hasLoaded && !this.isLoading && this.noRooms && this.isFilterActive
      )
    },
    propertyId() {
      return this.$route.query.propertyId
    }
  },
  methods: {
    async getRooms() {
      const rooms = await roomsApi.getRooms({
        propertyIds:
          this.filteredProperties.length > 0
            ? this.filteredProperties.join(',')
            : '',
        occupancy:
          this.filteredOccupancy.length > 0
            ? this.filteredOccupancy.join(',')
            : ''
      })
      if (rooms.data && rooms.data.length) {
        rooms.data.sort(
          (a, b) =>
            a['propertyName'].localeCompare(b['propertyName']) ||
            a['name'].localeCompare(b['name'])
        )

        this.rooms = rooms.data.map((room) => {
          return {
            ...room,
            tag: room.marketingName.slice(-3, -1)
          }
        })
      } else {
        this.rooms = []
        return []
      }
    },
    showRoomDetail(value) {
      this.$modal.show('room-detail-modal')
      this.selRoom = value
    },
    cancelPendingFilter() {
      if (this.filterDebounceTimer) {
        clearTimeout(this.filterDebounceTimer)
        this.filterDebounceTimer = null
      }
    },
    scheduleFilteredReload() {
      this.cancelPendingFilter()
      this.filterDebounceTimer = setTimeout(async () => {
        this.filterDebounceTimer = null
        if (this.isFiltering) {
          // A fetch is still in-flight: refetch once with the latest
          // filters when it finishes instead of stacking requests.
          this.filterDirty = true
          return
        }
        this.isFiltering = true
        this.isLoading = true
        try {
          do {
            this.filterDirty = false
            await this.getRooms()
          } while (this.filterDirty)
        } finally {
          this.isFiltering = false
          this.isLoading = false
        }
      }, this.filterDebounceMs)
    },
    filterProperties(id) {
      if (this.filteredProperties.includes(id)) {
        const index = this.filteredProperties.indexOf(id)
        this.filteredProperties.splice(index, 1)
      } else {
        this.filteredProperties.push(id)
      }
      this.scheduleFilteredReload()
    },
    filterOccupancy(id) {
      if (this.filteredOccupancy.includes(id)) {
        const index = this.filteredOccupancy.indexOf(id)
        this.filteredOccupancy.splice(index, 1)
      } else {
        this.filteredOccupancy.push(id)
      }
      this.scheduleFilteredReload()
    },
    async clearFilters() {
      this.cancelPendingFilter()
      this.filteredOccupancy = this.occupancy.map((item) => item.uuid)
      this.filteredProperties = []
      this.isFiltering = true
      this.isLoading = true
      try {
        await this.getRooms()
      } finally {
        this.isFiltering = false
        this.isLoading = false
      }
    },
    createRoom(rooms) {
      this.$router.push({ name: 'NewRoom', rooms: rooms })
    },
    triggerDelete(room) {
      this.deleting = true
      this.selRoom = room
    },
    triggerEdit(room) {
      this.$router.push({
        name: 'EditRoom',
        params: {
          roomId: room.uuid,
          rooms: this.rooms
        }
      })
    },
    async deleteRoom() {
      this.cancelPendingFilter()
      this.isLoading = true
      try {
        const { message, data } = await calls.DELETE('rooms', this.selRoom.uuid)
        await this.getRooms()
      } finally {
        this.isLoading = false
      }
      this.deleting = false
    },
    async loadProperties() {
      const { message, data } = await calls.GET('properties')
      this.properties = data
    }
  },
  async mounted() {
    this.isLoading = true
    try {
      if (this.propertyId) {
        this.filteredProperties.push(this.propertyId)
      }
      await this.getRooms()
      await this.loadProperties()
    } finally {
      this.hasLoaded = true
      this.isLoading = false
    }
  },
  destroyed() {
    this.cancelPendingFilter()
  }
}
</script>

<style scoped>
.rooms-body {
  background-color: #f5f6f8;
  display: flex;
  flex-flow: column nowrap;
  padding: 24px;
  overflow: hidden;
}

.rooms-top-container {
  display: flex;
  flex-direction: row nowrap;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  margin-bottom: 20px;
}

.rooms-nav-container {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: baseline;
  width: 430px;
}

.rooms-title {
  font-family: Montserrat;
  font-style: normal;
  font-weight: 800;
  font-size: 24px;
  line-height: 40px;
  display: flex;
  align-items: center;
  letter-spacing: 0.8px;
  color: #000000;
}

.rooms-grid {
  height: 75%;
  display: grid;
  gap: 12px;
  grid-auto-flow: row;
  grid-template-columns: repeat(auto-fill, 270px);
  overflow-y: auto;
  justify-content: center;
}

.rooms-loading {
  width: 100%;
}

.roomScreenButton {
  width: 192px;
  height: 35px;
  font-size: 14px;
  border: none;
  cursor: pointer;
}

#newTemplateButton {
  width: 160px;
  border-radius: 4px;
  background-color: #66b015;
  color: white;
  height: 40px;
  z-index: 2;
}

#newTemplateButton:hover {
  background-color: rgba(102, 176, 21, 0.7);
}

#filterButton {
  width: 120px;
  height: 40px;
  border-radius: 4px;
  background-color: white;
  color: #767675;
  margin-right: 10px;
}

#bodyTitle {
  text-align: left;
  font-weight: bold;
  margin-left: 30px;
}

.rooms-delete-background {
  position: fixed;
  z-index: 10;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.2);
}

.rooms-delete-container {
  position: relative;
  width: 380px;
  height: 126px;
  padding: 24px 48px 64px 48px;
  left: calc(50% - 238px);
  top: calc(50% - 91px);
  background-color: white;
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-between;
  align-items: flex-start;
}

.rooms-delete-title {
  font-family: Montserrat;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  color: #df000f;
  height: 22px;
  padding: 11px 0 11px 0;
}

.rooms-delete-subtitle {
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 15px;
  color: #192a3e;
  height: 20px;
  padding: 11px 0 11px 0;
}

.rooms-delete-buttons-container {
  height: 48px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  width: 376px;
  padding: 21px 0 21px 0;
}

button.rooms-delete-cancel,
button.rooms-delete-accept {
  width: 176px;
  height: 48px;
  border-radius: 4px;
  cursor: pointer;
}

button.rooms-delete-cancel {
  background: #ffffff;
  border: 1px solid #4a4a4a;
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  text-align: center;
  color: #4a4a4a;
}

button.rooms-delete-accept {
  background: #df000f;
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  text-align: center;
  color: #ffffff;
  border: none;
}

.empty-room-screen {
  width: 100%;
  padding-top: 10%;
  height: 90%;
}

.empty-room-screen div {
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 40px;
}

.room-empty-icon {
  width: 50%;
  height: 50%;
}

/* styles for new filter */

.right .down-arrow {
  position: absolute;
  right: 10px;
  top: 18px;
}

.right .select-btn {
  position: relative;
  width: 120px;
  height: 40px;
  background: #ffffff;
  border: 1px solid #cbd4dc;
  border-radius: 4px;
  color: #767675;
  font-size: 14px;
  /* margin-left: 16px; */
  text-align: left;
  cursor: pointer;
  margin-right: 10px;
  padding-left: 16px;
}

.right .new-chore {
  background: #66b015;
  border-radius: 4px;
  color: #ffffff;
  font-weight: 400;
  font-size: 14px;
  width: 160px;
  border: 1px solid #66b015;
  height: 40px;
  margin-left: 16px;
  cursor: pointer;
}

.v-popover.open .select-btn {
  border: 1px solid #66b015;
  color: #66b015;
}

.v-popover.open .select-btn img {
  transform: rotate(180deg);
}

/* Mobile Responsive Styles */
@media (max-width: 768px) {
  .rooms-body {
    padding: 16px;
    overflow: auto;
    padding-top: 24px;
  }

  .rooms-top-container {
    flex-direction: column;
    height: auto;
    gap: 16px;
    margin-bottom: 24px;
    align-items: flex-start;
  }

  .rooms-title {
    font-size: 20px;
    line-height: 28px;
    margin-bottom: 8px;
  }

  .rooms-nav-container {
    width: 100%;
    flex-direction: column;
    gap: 12px;
    align-items: stretch;
  }

  .right {
    width: 100%;
    flex-direction: column;
    gap: 8px;
  }

  .right .select-btn {
    width: 92vw !important;
    box-sizing: border-box !important;
    margin-left: 0;
    margin-right: 0;
    height: 44px;
    font-size: 16px;
  }

  .roomScreenButton {
    width: 92vw !important;
    height: 44px;
    font-size: 16px;
    box-sizing: border-box !important;
  }

  #newTemplateButton {
    width: 100%;
    height: 44px;
    font-size: 16px;
  }

  .rooms-grid {
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 16px;
    padding: 0 8px;
    height: auto;
    margin-bottom: 6rem;
  }

  .empty-room-screen {
    height: auto;
    padding: 40px 20px;
    text-align: center;
  }

  .room-empty-icon {
    width: 40%;
    height: auto;
    margin-bottom: 16px;
  }

  .empty-room-screen div {
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 8px;
  }

  .rooms-delete-container {
    width: 90%;
    left: 5%;
    transform: none;
  }

  /* Trigger class for dropdown button */
  .trigger {
    width: 100% !important;
    display: flex !important;
  }
}

@media (max-width: 480px) {
  .rooms-body {
    padding: 12px;
    padding-top: 20px;
  }

  .rooms-title {
    font-size: 18px;
    line-height: 24px;
  }

  .rooms-grid {
    grid-template-columns: 1fr;
    gap: 12px;
    padding: 0;
  }

  .right .select-btn {
    height: 40px;
    font-size: 16px;
  }

  .roomScreenButton {
    height: 40px;
    font-size: 16px;
  }

  #newTemplateButton {
    height: 40px;
    font-size: 16px;
  }

  .rooms-delete-container {
    width: 95%;
    left: 2.5%;
    padding: 20px;
  }
}

@media screen and (max-width: 648px) {
  .rooms-grid {
    grid-template-columns: 1fr !important;
    grid-template-rows: none !important;
    gap: 12px;
    padding: 0;
  }

  .rooms-body {
    padding: 16px;
    padding-top: 24px;
    overflow: auto;
  }

  .rooms-title {
    font-size: 18px;
    line-height: 24px;
    letter-spacing: 0;
  }

  .room-cell-buttons-container {
    justify-content: flex-end;
  }

  .rooms-top-container {
    flex-direction: column;
    height: auto;
    gap: 16px;
    margin-bottom: 24px;
    align-items: flex-start;
  }

  .rooms-nav-container {
    width: 100%;
    flex-direction: column;
    gap: 12px;
    align-items: stretch;
  }

  .right {
    width: 100%;
    flex-direction: column;
    gap: 8px;
  }

  .right .select-btn {
    width: 100%;
    margin-left: 0;
    margin-right: 0;
    height: 44px;
    font-size: 16px;
    box-sizing: border-box;
  }

  .roomScreenButton {
    width: 100%;
    height: 44px;
    font-size: 16px;
  }

  #newTemplateButton {
    width: 100%;
    height: 44px;
    font-size: 16px;
  }
}
</style>
